module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vessel"
  }, [
    [_c('el-alert', {
      attrs: {
        "title": "病人信息",
        "type": "info",
        "center": "",
        "closable": false
      }
    })], _vm._v(" "), _c('el-form', {
      staticClass: "demo-form-inline",
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "inline": true,
        "model": _vm.formInline
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "姓名"
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": true
      },
      model: {
        value: (_vm.formInline.name),
        callback: function($$v) {
          _vm.$set(_vm.formInline, "name", $$v)
        },
        expression: "formInline.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "性别"
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": true
      },
      model: {
        value: (_vm.formInline.gender),
        callback: function($$v) {
          _vm.$set(_vm.formInline, "gender", $$v)
        },
        expression: "formInline.gender"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "周岁"
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": true
      },
      model: {
        value: (_vm.formInline.age),
        callback: function($$v) {
          _vm.$set(_vm.formInline, "age", $$v)
        },
        expression: "formInline.age"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "电话"
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": true
      },
      model: {
        value: (_vm.formInline.phone),
        callback: function($$v) {
          _vm.$set(_vm.formInline, "phone", $$v)
        },
        expression: "formInline.phone"
      }
    })], 1)], 1), _vm._v(" "), [_c('el-alert', {
      attrs: {
        "title": "中药汤方",
        "type": "info",
        "center": "",
        "closable": false
      }
    })], _vm._v(" "), _c('el-collapse', {
      attrs: {
        "accordion": ""
      }
    }, _vm._l((_vm.foldData), function(item, index) {
      return _c('el-collapse-item', {
        key: index,
        attrs: {
          "name": index,
          "title": item.recipeName
        }
      }, [_c('el-table', {
        attrs: {
          "data": item.recipeItemResponses,
          "border": "",
          "row-class-name": _vm.tableRowClassName
        }
      }, [_c('el-table-column', {
        attrs: {
          "type": "index",
          "width": "auto"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "align": "center",
          "prop": "value",
          "label": "药品名称",
          "width": "auto"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "align": "center",
          "label": "数量",
          "width": "auto"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [_c('el-input', {
              attrs: {
                "size": "small",
                "placeholder": "请输入内容"
              },
              on: {
                "change": function($event) {
                  return _vm.numberchangeAccordion($event, scope.$index, index)
                }
              },
              model: {
                value: (scope.row.number),
                callback: function($$v) {
                  _vm.$set(scope.row, "number", $$v)
                },
                expression: "scope.row.number"
              }
            })]
          }
        }], null, true)
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "align": "center",
          "prop": "recordNumber",
          "label": "库存数量",
          "width": "auto"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "align": "center",
          "prop": "inventoryWarning",
          "label": "库存预警",
          "width": "auto"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "align": "center",
          "prop": "unit",
          "label": "单位",
          "width": "auto"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "align": "center",
          "prop": "retailPrice",
          "label": "单价",
          "width": "auto"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "label": "操作",
          "width": "120"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [_c('el-button', {
              attrs: {
                "type": "text",
                "size": "small"
              },
              nativeOn: {
                "click": function($event) {
                  $event.preventDefault();
                  return _vm.deleteRows(scope.$index, _vm.foldData, index)
                }
              }
            }, [_vm._v("移除")]), _vm._v(" "), (scope.row.number != 0) ? _c('el-button', {
              attrs: {
                "type": "text",
                "size": "small"
              },
              on: {
                "click": function($event) {
                  return _vm.substitute(scope.$index, scope.row, index)
                }
              }
            }, [_vm._v("替换")]) : _vm._e()]
          }
        }], null, true)
      })], 1), _vm._v(" "), _c('el-dialog', {
        attrs: {
          "title": "药品替换",
          "visible": _vm.dialogFormVisible,
          "width": "35%"
        },
        on: {
          "update:visible": function($event) {
            _vm.dialogFormVisible = $event
          }
        }
      }, [
        [_c('el-select', {
          attrs: {
            "placeholder": "请选择替换的药品"
          },
          on: {
            "change": function($event) {
              return _vm.selectVariation(index)
            }
          },
          model: {
            value: (_vm.val),
            callback: function($$v) {
              _vm.val = $$v
            },
            expression: "val"
          }
        }, _vm._l((_vm.cfArr), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.value,
              "value": item.id
            }
          })
        }), 1)], _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.dialogFormVisible = false
            }
          }
        }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.sure
          }
        }, [_vm._v("确 定")])], 1)
      ], 2), _vm._v(" "), _c('div', {
        staticClass: "add"
      }, [_c('el-autocomplete', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "fetch-suggestions": _vm.querySearchAsync,
          "placeholder": "请输入内容"
        },
        on: {
          "select": _vm.handleSelects
        },
        nativeOn: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.location(index)
          }
        },
        model: {
          value: (_vm.rowDatas),
          callback: function($$v) {
            _vm.rowDatas = $$v
          },
          expression: "rowDatas"
        }
      })], 1), _vm._v(" "), _c('el-form', {
        staticStyle: {
          "margin-top": "30px"
        },
        attrs: {
          "label-position": _vm.labelPosition,
          "label-width": "130px"
        }
      }, [_c('el-form-item', {
        attrs: {
          "label": "汤方名："
        }
      }, [_c('el-input', {
        attrs: {
          "placeholder": "请输入汤方名",
          "disabled": true
        },
        model: {
          value: (item.recipeName),
          callback: function($$v) {
            _vm.$set(item, "recipeName", $$v)
          },
          expression: "item.recipeName"
        }
      })], 1), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "label": "副数："
        }
      }, [_c('el-input-number', {
        attrs: {
          "type": "number",
          "min": 1,
          "disabled": true
        },
        model: {
          value: (item.quantity),
          callback: function($$v) {
            _vm.$set(item, "quantity", $$v)
          },
          expression: "item.quantity"
        }
      })], 1), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "label": "药袋价格："
        }
      }, [_c('el-select', {
        attrs: {
          "placeholder": "请选择",
          "disabled": ""
        },
        model: {
          value: (item.bagsCost),
          callback: function($$v) {
            _vm.$set(item, "bagsCost", $$v)
          },
          expression: "item.bagsCost"
        }
      }, _vm._l((_vm.medicineBag), function(item, index) {
        return _c('el-option', {
          key: index,
          attrs: {
            "label": item.label,
            "value": item.value
          }
        })
      }), 1)], 1), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "label": "系数："
        }
      }, [_c('el-input-number', {
        attrs: {
          "precision": 1,
          "min": 1,
          "disabled": true
        },
        model: {
          value: (item.coefficient),
          callback: function($$v) {
            _vm.$set(item, "coefficient", $$v)
          },
          expression: "item.coefficient"
        }
      })], 1), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "label": "煎服法："
        }
      }, [_c('el-input', {
        attrs: {
          "placeholder": "请输入煎服法",
          "disabled": true
        },
        model: {
          value: (item.eatType),
          callback: function($$v) {
            _vm.$set(item, "eatType", $$v)
          },
          expression: "item.eatType"
        }
      })], 1), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "label": "忌口及日常护理："
        }
      }, [_c('el-input', {
        attrs: {
          "autosize": "",
          "type": "textarea",
          "placeholder": "请输入忌口及日常护理",
          "disabled": true
        },
        model: {
          value: (item.note),
          callback: function($$v) {
            _vm.$set(item, "note", $$v)
          },
          expression: "item.note"
        }
      })], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "inOne-TabBttom"
      }, [_c('el-button', {
        attrs: {
          "type": "warning"
        },
        on: {
          "click": function($event) {
            return _vm.preserveRemind(index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-floppy-o"
      }), _vm._v("保存\n        ")])], 1)], 1)
    }), 1)
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03f4cffc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/inquiry/compileC.vue
// module id = 992
// module chunks = 2